import React from 'react';
import { GeneralSetupForm } from './GeneralSetupForm';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { SquareButton } from 'components';
import { NewFeatureBanner } from 'components/NewFeatureBanner';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';

const useStyles = createUseStyles((theme: Theme) => ({
  topMargin: {
    paddingTop: theme.marginBase * 6,
    maxWidth: 800,
    margin: 'auto',

    paddingRight: theme.marginBase * 3,
    paddingLeft: theme.marginBase * 3,
  },
  button: {
    marginBottom: theme.marginBase * 4,
  },
}));

export const StudySetup = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <AnalyticsCategoryProvider category={Categories.STUDY_CREATION}>
      <div className={classes.topMargin}>
        <NewFeatureBanner />
        <GeneralSetupForm
          head={
            <SquareButton
              color="ink"
              to="/"
              icon="ri-close-line"
              className={classes.button}
            />
          }
        />
      </div>
    </AnalyticsCategoryProvider>
  );
};
